import { render } from "./AcquisitionItemsWorkspace.vue?vue&type=template&id=29cee07a&scoped=true"
import script from "./AcquisitionItemsWorkspace.vue?vue&type=script&lang=js"
export * from "./AcquisitionItemsWorkspace.vue?vue&type=script&lang=js"

import "./AcquisitionItemsWorkspace.vue?vue&type=style&index=0&id=29cee07a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29cee07a"]])

export default __exports__